import { useTheme } from '@mui/material/styles';
import React from 'react';

import ProcessStepCircle from './ProcessStepCircle';
import {
  CircleContainer,
  ElementContainer,
  VerticalContainer,
} from './ProcessStepper.style';

export default function ProcessStepper({
  stepNames = [],
  stepColors = [],
  skippedSteps = [],
  stepIcons = [],
  currentStep = 0,
  allBlack = false,
  circleColors,
  style,
}: {
  stepNames?: React.ReactNode[];
  stepColors?: string[];
  skippedSteps?: number[];
  stepIcons?: string[];
  currentStep?: number;
  allBlack?: boolean;
  circleColors?: { active: string; inactive: string; skipped: string };
  style?: React.CSSProperties;
}) {
  const { palette } = useTheme();

  const resolvedCircleColors = circleColors ?? {
    active: palette.text.primary,
    inactive: palette.text.secondary,
    skipped: palette.warning.main,
  };

  function getInnerColor(index: number) {
    if (skippedSteps.includes(index)) {
      return resolvedCircleColors.skipped;
    } else if (allBlack || currentStep === index) {
      return resolvedCircleColors.active;
    }
    return resolvedCircleColors.inactive;
  }

  return (
    <VerticalContainer style={style}>
      {stepNames.map((name, index) => (
        <ElementContainer
          color={stepColors[index]}
          data-testid={`process-stepper-container-${index + 1}`}
          key={`process-stepper-element-${index}`}
        >
          <CircleContainer>
            <ProcessStepCircle
              icon={stepIcons[index] ? stepIcons[index] : ''}
              innerColor={getInnerColor(index)}
              outerColor={palette.grey.A200}
            />
          </CircleContainer>
          {name}
        </ElementContainer>
      ))}
    </VerticalContainer>
  );
}
